import { Button } from '@/components/ui/button.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.js';
import { ChevronDown } from 'lucide-react';
import { isCoach, isEdgeCoach } from '@airreading/common';
import { AirAdminMenuItems } from '@/routes/_layout/users/-components/manage-air-admin.js';
import { ManageEdgeCoach } from '@/routes/_layout/users/-components/manage-edge-coach.js';
import { PromoteCoach } from '@/routes/_layout/users/-components/promote-coach.js';
import { ManageCoach } from '@/routes/_layout/users/-components/manage-coach.js';
import { SingleUserFull } from '@airreading/common/data';

interface ManagePermissionsDropdownProps {
  user: SingleUserFull;
}

export function ManagePermissionsDropdown({ user }: ManagePermissionsDropdownProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" icon={ChevronDown}>
          Manage permissions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {isCoach(user) ? (
          <ManageCoach
            trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Delete teacher role</DropdownMenuItem>}
            user={user}
          />
        ) : (
          <PromoteCoach
            trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Promote as teacher</DropdownMenuItem>}
            user={user}
          />
        )}

        <AirAdminMenuItems user={user} />

        <ManageEdgeCoach
          user={user}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              {isEdgeCoach(user) ? 'Remove Edge tutors' : 'Add Edge tutors'}
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
